<template>
    <div class="modal hide fade in" id="modalAddReferencia" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{this.Titulo}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
            <div class="col-12 padding"  id="Busqueda_div" v-if="this.MostrarBusqueda == true">
                <div class="row col-12">
                    <div class="form-group col-6" id="Busqueda_div">
                          <label>Área</label>
                          <CAreas
                          v-on:valorParaElPadre="cambioDeArea" 
                          :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                          :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                          :idDelInput="'filtroDeBusqueda_Area'" 
                          :parametros="BusquedaForm.parametros_Area" 
                          :valorDefinido="BusquedaForm.parametros_Area.areaId" 
                          :key="BusquedaForm.parametros_Area.areaId"
                          >
                          </CAreas>
                    </div>
                    <div class="form-group col-6" id="BusquedaDoc_div" v-if="BusquedaForm.parametros_Area.areaId!=undefined && BusquedaForm.parametros_Area.areaId!=null && BusquedaForm.parametros_Area.areaId>0 && AreaValida==true">
                          <label>Tipo de Documento</label>
                          <CTipoDocumento
                          v-on:valorParaElPadre="cambioDocumento"
                          :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                          :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                          :idDelInput="'filtroDeBusqueda_Documento'" 
                          :parametros="BusquedaForm.parametros_TipoDocumento" 
                          :valorDefinido="BusquedaForm.parametros_TipoDocumento.tipoDocumentoId" 
                          :key="BusquedaForm.parametros_TipoDocumento.tipoDocumentoId"
                      ></CTipoDocumento>
                    </div>
                </div>
                <div class="row col-12">
                  <div class="form-group col-6" id="Anio_div" v-if="BusquedaForm.parametros_TipoDocumento.tipoDocumentoId!=undefined && BusquedaForm.parametros_TipoDocumento.tipoDocumentoId!=null && BusquedaForm.parametros_TipoDocumento.tipoDocumentoId>0">
                      <label>Año</label>
                      <input class="form-control" type="number" placeholder="####" v-model="BusquedaForm.Anio" />
                  </div>
                  <div class="form-group col-6" id="Consecutivo_div" v-if="BusquedaForm.parametros_TipoDocumento.tipoDocumentoId!=undefined && BusquedaForm.parametros_TipoDocumento.tipoDocumentoId!=null && BusquedaForm.parametros_TipoDocumento.tipoDocumentoId>0">
                      <label>Consecutivo</label>
                      <input class="form-control" type="number" placeholder="####" v-model="BusquedaForm.Consecutivo" />
                  </div>
                </div>
                <div class="row col-12">
                  <div class="form-group col-12 text-right">
                    <button class="btn btn-secondary btn-sm" @click='CrearPeticion()' >Buscar Documento</button>
                  </div>
                </div>
            </div>
            <div class="col-12 padding" id="Resultado_div" v-if="this.MostraResultado == true">
              <div class="row col-12">
                <div class="form-group col-6" id="Area_div">
                  <label>Área</label>
                  <input type="text" class="form-control" v-model="ReferenciaDocumento.Area.Nombre" readonly />
                </div>
                <div class="form-group col-6" id="Tipo_div">
                  <label>Tipo</label>
                  <input type="text" class="form-control" v-model="ReferenciaDocumento.TipoDocumento.Nombre" readonly />
                </div>
              </div>
              <div class="row col-12">
                <div class="form-group col-6" id="Anio_div">
                  <label>Año</label>
                  <input type="text" class="form-control" v-model="ReferenciaDocumento.Anio" readonly />
                </div>
                <div class="form-group col-6" id="Tipo_div">
                  <label>Consecutivo</label>
                  <input type="text" class="form-control" v-model="ReferenciaDocumento.Consecutivo" readonly />
                </div>
              </div>
              <div class="row col-12">  
                <div class="form-group col-12" id="etiquetaVolumen_div">
                  <h6>Volumenes del Documento</h6>
                </div>
                <div class="form-group col-12" id="Tabla_div">
                  <div id="Volumen_table" class="table-reponsive">
                    <table class="table table-striped table-light table-hover">
                      <thead class="thead-dark">
                        <tr>
                          <th>No.</th>
                          <th>Fojas</th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="ReferenciaDocumento.Volumenes.length <= 0">
                          <td colspan="12" class="text-center">No hay registro del Volumen</td>
                        </tr>
                        <tr v-else v-for="detalle in ReferenciaDocumento.Volumenes" :key="detalle.VolumenId">
                          <td>{{detalle.NumVolumen}}</td>
                          <td>{{detalle.Fojas}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row col-12 align-items-center">
                <div class="form-group col-6" id="refDoc_div">
                  <label>Referencia por</label>
                  <CReferencia
                    v-on:valorParaElPadre="cambioDeReferencia" 
                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :idDelInput="'filtroDeBusqueda_Referencia'" 
                    :parametros="parametros_EstatusReferencia" 
                    :valorDefinido="parametros_EstatusReferencia.tipoEstatusReferenciaId" 
                    :key="parametros_EstatusReferencia.tipoEstatusReferenciaId"
                    ></CReferencia>
                </div>
                <div class="form-group col-6 text-right">
                  <button class="btn btn-secondary btn-sm" @click='VerificarVolumenes(DocumentoModal, ReferenciaDocumento)' >Continuar Referencia</button>
                </div>
              </div>  
            </div>
            <div class="col-12 padding" id="Volumenes_div" v-if="this.MostrarFusion == true">
              <div class="row col-12" id="VolumenesUnicos_div" v-if="this.primarioUnico==true && this.secundarioUnico == true">
                <div class="form-group col-6" id="FojasP_div" v-if="EditVolPrimario == false">
                  <label>Fojas Volumen Principal</label>
                  <input type="number" class="form-control" v-model="VolumenPrincipal.Fojas" readonly />
                </div>
                <div class="form-group col-6" id="FojasPEdit_div" v-else>
                  <label>Fojas Volumen Principal</label>
                  <input type="number" class="form-control" placeholder="####" v-model="VolumenPrincipal.Fojas"/>
                </div>
                <div class="form-group col-6" id="FojasS_div" v-if="EditVolSecundario == false">
                  <label>Fojas Volumen Referencia</label>
                  <input type="number" class="form-control" v-model="VolumenSecundario.Fojas" readonly />
                </div>
                <div class="form-group col-6" id="FojasSEdit_div" v-else>
                  <label>Fojas Volumen Referencia</label>
                  <input type="number" class="form-control" placeholder="####" v-model="VolumenSecundario.Fojas"/>
                </div>
                <div class="form-group col-12">
                  <label>Gestíon de Volumenes</label>
                </div>
                <div class= "form-group col-6" id="checkFusion">
                    <input type="checkbox" class="form-check-input" id="fusionVolumen" v-model="chkFusion">
                    <label class="form-check-label" for="exampleCheck1">Fusíon de Volumenes</label>
                </div>
                <div class= "form-group form-check col-6" id="checkNuevo">
                    <input type="checkbox" class="form-check-input" id="NuevoVolumen" v-model="chkNuevoVolumen">
                    <label class="form-check-label" for="exampleCheck1">Nuevo Volumen</label>
                </div>
                <div class="form-group col-12 text-right">
                  <button class="btn btn-secondary btn-sm" @click='Finalizar()' >Finalizar Referencia</button>
                </div>
              </div>
              <div class="row col-12" id="VariosPrimario_div" v-if="ListaPrimario == true && this.secundarioUnico ==true">
                <div class="form-group col-12">
                  <label>Volúmenes del Documento Principal</label>
                  <div id="Volumen_table" class="table-reponsive">
                    <table class="table table-striped table-light table-hover">
                      <thead class="thead-dark">
                        <tr>
                          <th>No.</th>
                          <th>Fojas</th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="DocumentoModal.Volumenes.length <= 0">
                          <td colspan="12" class="text-center">No hay registro del Volumen</td>
                        </tr>
                        <tr v-else v-for="detalle in DocumentoModal.Volumenes" :key="detalle.VolumenId">
                          <td>{{detalle.NumVolumen}}</td>
                          <td>{{detalle.Fojas}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="form-group col-12">
	                <div class="form-group col-6" id="FojasS_div" v-if="EditVolSecundario == false">
                    <label>Fojas Volumen Referencia</label>
                    <input type="number" class="form-control" v-model="VolumenSecundario.Fojas" readonly />
	                </div>
                  <div class="form-group col-6" id="FojasSEdit_div" v-else>
                    <label>Fojas Volumen Referencia</label>
                    <input type="number" class="form-control" placeholder="####" v-model="VolumenSecundario.Fojas"/>
                  </div>
                </div>
                <div class= "form-group col-12" id="etiqueta1">
                    <label>El(los) Volumen(es) del Documento de Referencia se anexaran como un nuevo volumen(es) del documento principal</label>
                  </div>
               
                <div class="form-group col-12 text-right">
                  <button class="btn btn-secondary btn-sm" @click='Finalizar()' >Finalizar Referencia</button>
                </div>
              </div>
              <div class="row col-12" id="VariosSecundario_div" v-if="ListaPrimario==true && ListaSecundario == true">
                <div class="form-group col-12">
                  <div id="VolumenPrincipal_table" class="table-reponsive">
                    <label>Volúmenes del Documento Principal</label>
                    <table class="table table-striped table-light table-hover">
                      <thead class="thead-dark">
                        <tr>
                          <th>No.</th>
                          <th>Fojas</th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="DocumentoModal.Volumenes.length <= 0">
                          <td colspan="12" class="text-center">No hay registro del Volumen</td>
                        </tr>
                        <tr v-else v-for="detalle in DocumentoModal.Volumenes" :key="detalle.VolumenId">
                          <td>{{detalle.NumVolumen}}</td>
                          <td>{{detalle.Fojas}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="form-group col-12">
                  <label>Volúmenes del Documento a Referencia</label>
                  <div id="VolumenScundario_table" class="table-reponsive">
                    <table class="table table-striped table-light table-hover">
                      <thead class="thead-dark">
                        <tr>
                          <th>No.</th>
                          <th>Fojas</th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="ReferenciaDocumento.Volumenes.length <= 0">
                          <td colspan="12" class="text-center">No hay registro del Volumen</td>
                        </tr>
                        <tr v-else v-for="detalle in ReferenciaDocumento.Volumenes" :key="detalle.VolumenId">
                          <td>{{detalle.NumVolumen}}</td>
                          <td v-if="EditRowListado==false" >{{detalle.Fojas}}</td>
                          <td v-else><input type="number" v-model="detalle.Fojas"></td>
                          <!-- <td v-else>{{detalle.Fojas}}</td> -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class= "form-group col-12" id="etiqueta2">
                    <label>El(los) Volumen(es) del Documento de Referencia se anexaran como un nuevo volumen(es) del documento principal</label>
                </div>
                <div class="form-group col-12 text-right">
                  <button class="btn btn-secondary btn-sm" @click='Finalizar()' >Finalizar Referencia</button>
                </div>
              </div>

              <div class="row col-12" id="PrincipalUnicoSecundarioLista_div" v-if="primarioUnico== true && ListaSecundario == true">
                <div class="form-group col-6" id="FojasP_div" v-if="EditVolPrimario == false">
                  <label>Fojas Volumen Principal</label>
                  <input type="number" class="form-control" v-model="VolumenPrincipal.Fojas" readonly />
                </div>
                <div class="form-group col-6" id="FojasPEdit_div" v-else>
                  <label>Fojas Volumen Principal</label>
                  <input type="number" class="form-control" placeholder="####" v-model="VolumenPrincipal.Fojas"/>
                </div>
                <div class="form-group col-12">
                  <label>Volúmenes del Documento a Referencia</label>
                  <div id="VolumenScundario_table" class="table-reponsive">
                    <table class="table table-striped table-light table-hover">
                      <thead class="thead-dark">
                        <tr>
                          <th>No.</th>
                          <th>Fojas</th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="ReferenciaDocumento.Volumenes.length <= 0">
                          <td colspan="12" class="text-center">No hay registro del Volumen</td>
                        </tr>
                        <tr v-else v-for="detalle in ReferenciaDocumento.Volumenes" >
                          <td>{{detalle.NumVolumen}}</td>
                          <td v-if="EditRowListado==false" >{{detalle.Fojas}}</td>
                          <td v-else-if="detalle.UsuarioQueRegistro.IdUsuario == 0"><input type="number" v-model="detalle.Fojas"></td>
                          <td v-else>{{detalle.Fojas}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class= "form-group col-12" id="etiqueta2">
                    <label>El(los) Volumen(es) del Documento de Referencia se anexaran como un nuevo volumen(es) del documento principal</label>
                </div>
                <div class="form-group col-12 text-right">
                  <button class="btn btn-secondary btn-sm" @click='Finalizar()' >Finalizar Referencia</button>
                </div>
              </div>
            </div>
        </div>

        <div class="modal-footer" >
            <!-- <button type="button" class="btn btn-dark" id="botonCancelar" >Cancelar</button>
            <button type="button" class="btn btn-dark" id="botonAceptar" >Aceptar</button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'

export default {

    components:{
      CAreas : catalogos.ArchivoJudicial.C001Areas,
      CTipoDocumento: catalogos.PJ.C004TipoDocumento,
      CReferencia: catalogos.ArchivoJudicial.C014TipoEstatusReferencia
    }, 
    data(){
      return{
          enumeraciones,
          BusquedaForm: {
            Anio: "",
            Consecutivo: "",
            parametros_Area: {
              areaId: -1,
              conMaterias: true,
            },
            parametros_TipoDocumento: {
              tipoDocumentoId: -1,
              areaId: -1,
              materiaId: -1,
              soloDocumentosPrincipales: true
            }
          },
          parametros_EstatusReferencia:{
            tipoEstatusReferenciaId: -1
          },
          DocumentoModal: {
              InventarioDocumentoId: 0,
              Area: {
                  AreaId: 0,
                  Nombre: ""
              },
              TipoDocumento: {
                  TipoDocumentoId: 0,
                  Nombre: ""
              },
              Materia: { 
              },
              Anio: "",
              Consecutivo: "",
              Volumenes: [],
              Referencias :[]
          },
          ReferenciaDocumento: {
            InventarioDocumentoId: 0,
              Area: {
                  AreaId: 0,
                  Nombre: ""
              },
              TipoDocumento: {
                  TipoDocumentoId: 0,
                  Nombre: ""
              },
              Materia: { 
              },
              Anio: "",
              Consecutivo: "",
              Volumenes: [],
              Referencias :[]
          },
          MostrarBusqueda: false,
          MostraResultado: false,
          MostrarFusion: false, 
          Titulo: "",
          VolumenPrincipal : {
             VolumenId:0,
             Fojas: 0,
             Contenedor: 0,
             Area: {
                    AreaId: Number,
                },
             EstatusVolumenes: {
                TipoEstatusVolumenId: Number,
                },
             InventarioDocumentoId:0,
             UsuarioQueRegistro: {
                    IdUsuario: 0,
                    Nombre: "",
                    ApellidoPaterno: "",
                    ApellidoMaterno:""
                },
             FechaRegistro: null
          },
          VolumenSecundario: {
            VolumenId:0,
            Fojas: 0,
            Contenedor: 0,
            Area: {
                    AreaId: Number,
                },
            EstatusVolumenes: {
                TipoEstatusVolumenId: Number,
                },
            InventarioDocumentoId:0,
            UsuarioQueRegistro: {
                    IdUsuario: 0,
                    Nombre: "",
                    ApellidoPaterno: "",
                    ApellidoMaterno:""
                },
            FechaRegistro: null
          },
          ListaVolumenSecundario: [],
          ListaFinalReferencias: [],
          MovimientosFinales: [],
          primarioUnico: false,
          secundarioUnico: false,
          ListaPrimario: false,
          ListaSecundario: false,
          chkFusion: false,
          chkNuevoVolumen: false,
          EditVolPrimario: false,
          EditVolSecundario: false,
          EditRowListado: false,
          AreaValida: true
        }
    },
    props:{
        DocumentoPrincipal: {}
    },
    methods: {
        cambioDeReferencia(datos){
            this.parametros_EstatusReferencia.tipoEstatusReferenciaId = parseInt(datos.target.value);
        },
        cambioDeArea(datos){
            this.BusquedaForm.parametros_Area.areaId = parseInt(datos[0].target.value);
            
            if(this.BusquedaForm.parametros_Area.areaId>0)
            {
                this.BusquedaForm.parametros_TipoDocumento.areaId = datos[1].AreaId;
                if (datos[1].Materias != undefined && datos[1].Materias != null && datos[1].Materias.length>0 )
                {   
                    this.AreaValida = true;
                    if(datos[1].Materias.length == 1)
                    {
                        this.BusquedaForm.parametros_TipoDocumento.materiaId = datos[1].Materias[0].MateriaId
                    }
                    else 
                    {
                        this.BusquedaForm.parametros_TipoDocumento.materiaId = datos[1].Materias[1].MateriaId
                    }
                }
                else
                {
                    this.AreaValida = false;
                    comun.mensajeDeAlerta("No se encontraron Tipos de Documentos del área seleccionada.", null, null);
                }

            }
            else{
                this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId = -1;
                this.BusquedaForm.parametros_TipoDocumento.areaId = null;
                this.BusquedaForm.parametros_TipoDocumento.materiaId = null;
            }


        },
        cambioDocumento(datos){
            this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId = parseInt(datos.target.value);
        },
        Mostrar: function () {
          $('#modalAddReferencia').modal('show');
          $('#closeModal').unbind('click').click(this.ModalClose);
          $('#botonCancelar').unbind('click').click(this.ModalClose);
          $('#botonAceptar').unbind('click').click(this.AgregarReferencia);
        },
        ModalClose: function(){
          $('#modalAddReferencia').modal('hide');
          this.$emit('dialogo', false);
        },
        obtenFechaConFormato: function(fechaRegistro) {
          return moment(fechaRegistro).format("DD-MM-YYYY");
        },
        CrearPeticion(){
            if(this.ValidaDatosBuqueda())
            {
             var Envio = {
                "AreaId" :  this.BusquedaForm.parametros_Area.areaId,
                "TipoDocumentoId": this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId,
                "Anio": this.BusquedaForm.Anio,
                "Consecutivo": this.BusquedaForm.Consecutivo
                //"InventarioDocumentoId": this.Documento.InventarioDocumentoId
              }
              this.BuscarDocumentoAReferencia(Envio);
            }
        },
        BuscarDocumentoAReferencia(peticion){
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.ArchivoJudicial.ObtenerParaReferencia, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                }
                else
                {
                  comun.SeEstaCargandoInformacion(false);
                  var VerificaDocumento = respuesta.data.GetDocumentoPorId;
                  
                  if(VerificaDocumento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4)
                  {
                    if(this.VerificarReferencia(this.DocumentoModal, VerificaDocumento) == true)
                    {
                      this.ListaVolumenSecundario = VerificaDocumento.Volumenes;
                      this.ReferenciaDocumento = VerificaDocumento;
                      //this.ReferenciaDocumento.TipoEstatusInventario.TipoEstatusInventarioId = 4;
                      this.MostrarBusqueda = false;
                      this.MostraResultado= true;
                      this.MostrarFusion = false;
                      this.Titulo = "Referencia de Documento: Resultado.";
                    }
                  }
                  else{
                    comun.mensajeDeAlerta("Este Documento ya es referencia", null, null);
                  }
                  
                }
                comun.SeEstaCargandoInformacion(false);
                        
                })
                .catch(e=> {
                console.log("No Hay Respuesta del Servidor", e);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
        },
        AgregarReferencia(){
          var sumaVol1 = 0;
          var sumaVol2 = 0;
          var volId1 = 0;
          var volId2 = 0;
          if(this.chkFusion == true)
          {
            sumaVol1 = parseInt(this.VolumenPrincipal.Fojas) + parseInt(this.VolumenSecundario.Fojas);
            volId1= this.VolumenPrincipal.VolumenId;
          }
          else {
            sumaVol1= parseInt(this.VolumenPrincipal.Fojas);
            volId1= this.VolumenPrincipal.VolumenId;
          };
          if(this.chkNuevoVolumen)
          {
            volId2 =null;
            sumaVol2 = parseInt(this.VolumenSecundario.Fojas);
          }
          var ListaSecundario= this.ListaFinalReferencias;
          var Movimientos = this.MovimientosFinales;
          var peticion = {
                "DocumentoReferencia": {
                  "InventarioDocumentoId":  this.ReferenciaDocumento.InventarioDocumentoId,
                  "TipoEstatusInventario": {"TipoEstatusInventarioDocumentoId": 4}
                  }, 
                "Referencia": {
                    "InventarioDocumentoId": this.DocumentoModal.InventarioDocumentoId,
                    "DocumentoReferenciaId": this.ReferenciaDocumento.InventarioDocumentoId,
                    "TipoReferencia": {"TipoEstatusReferenciaId": this.parametros_EstatusReferencia.tipoEstatusReferenciaId}
                  },
                "VolumenPrincipal": {
                  "VolumenId": volId1,
                  "Fojas": sumaVol1,
                  "Contenedor": this.VolumenPrincipal.Contenedor,
                  "Area": {"AreaId": parseInt(this.DocumentoModal.Area.AreaId)},
                  "InventarioDocumentoId": this.VolumenPrincipal.InventarioDocumentoId,
                  "EstatusVolumenes":{ "TipoEstatusVolumenId": parseInt(this.VolumenPrincipal.EstatusVolumenes.TipoEstatusVolumenId )},
                  "UsuarioQueRegistra": 0,
                  "FechaRegistro": null

                },
                "VolumenSecundario": {
                  "VolumenId": volId2,
                  "Fojas": sumaVol2,
                  "Contenedor": this.VolumenSecundario.Contenedor,
                  "Area": {"AreaId": parseInt(this.DocumentoModal.Area.AreaId)},
                  "InventarioDocumentoId": this.VolumenPrincipal.InventarioDocumentoId,
                  "EstatusVolumenes":{ "TipoEstatusVolumenId": parseInt(this.VolumenPrincipal.EstatusVolumenes.TipoEstatusVolumenId )},
                  "UsuarioQueRegistra": 0,
                  "FechaRegistro": null
                },
                ListaSecundario,
                Movimientos,
                "ListaPrincipal": this.ListaPrimario,
                "Fusion": this.chkFusion,
                "NuevoVol": this.chkNuevoVolumen

              };
            console.log(peticion);
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.Referencia, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
              if (respuesta.data.SiHayError){
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                comun.SeEstaCargandoInformacion(false);
              }
              else
              {
                comun.mensajeDeAlerta("Se ha agregado referencia al documento", null, null);
                comun.SeEstaCargandoInformacion(false);
                this.ModalClose();
              }
              comun.SeEstaCargandoInformacion(false);
                          
              })
              .catch(e=> {
              console.log("No Hay Respuesta del Servidor", e);
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
        },
        ValidaDatosBuqueda(){
            //aqui validamos los parametros de entrada para busqueda.
                if(this.BusquedaForm.parametros_Area == null || this.BusquedaForm.parametros_Area.areaId == -1)
                    { comun.mensajeDeAlerta("Indicar el área del Documento.", null, null);
                    return false;}
                if(this.BusquedaForm.parametros_TipoDocumento ==null || this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId == -1)
                    { comun.mensajeDeAlerta("Indicar el tipo del Documento.", null, null);
                    return false;}
                if(this.BusquedaForm.Anio =="" ||this.BusquedaForm.Anio == null )
                    {comun.mensajeDeAlerta("Complete el año del Documento.", null, null)
                    return false;}
                if(this.BusquedaForm.Anio.length != 4)
                    {comun.mensajeDeAlerta("El formato del año debe contener 4 digitos.", null, null)
                    return false;}
                if (this.BusquedaForm.Consecutivo =="" ||this.BusquedaForm.Consecutivo == null)
                    {comun.mensajeDeAlerta("Complete el Consecutivo del Documento.", null, null)
                    return false;}
                    if(this.BusquedaForm.Consecutivo.length != 4)
                    {comun.mensajeDeAlerta("El formato del consecutivo debe contener 4 digitos.", null, null)
                    return false;}
                return true
        },
        VerificarReferencia(principal, referencia){
          var ConteoUbicacion = 0;
          var ConteoRecepcion = 0;
          var AreaPrincipal = principal.Area.AreaId;
          $.each(referencia.Volumenes, function(index, listado)
          {
            if(AreaPrincipal != listado.Area.AreaId)
            {
              ConteoUbicacion +=1;
            }
            else{
                if(listado.MovimientoVolumen.FechaRecepcion==null)
                {
                  ConteoRecepcion+=1;
                }
            }
          });

          if(ConteoUbicacion > 0)
          {
            comun.mensajeDeAlerta("El Documento a Referencia no tiene ubicación fisica en " + principal.Area.Alias + ", Verificar si esta en proceso de Recepción en Movimientos", null, null);
            return false;
          }
          else{ 
            if(ConteoRecepcion > 0)
            {
              comun.mensajeDeAlerta("El Documento tiene movimiento de envío a " + principal.Area.Alias + ", pero no se ha recibido", null, null);
              return false;
            }
            else{
                 return true;
            }
           }
        },
        VerificarVolumenes(principal, referencia){
          if(this.parametros_EstatusReferencia.tipoEstatusReferenciaId!=-1)
          {
            this.MostrarBusqueda = false;
            this.MostraResultado = false;
            this.MostrarFusion = true;
            this.Titulo = "Referencia de Documento: Volumenes"
            if(principal.Volumenes.length==1)
            {
              var vol = 0;
              var hojas= 0;
              var Contenedor = 0;
              var Estatus = 0;

              $.each(principal.Volumenes, function(index, lista){
                vol = lista.VolumenId;
                hojas=lista.Fojas
                Contenedor = lista.Contenedor;
                Estatus = lista.EstatusVolumenes.TipoEstatusVolumenId;
              });

              this.VolumenPrincipal.VolumenId= vol;
              this.VolumenPrincipal.Fojas= hojas;
              this.VolumenPrincipal.Contenedor = Contenedor;
              this.VolumenPrincipal.EstatusVolumenes.TipoEstatusVolumenId = Estatus;
              this.primarioUnico = true;

              if(this.VolumenPrincipal.Fojas == 0)
              {

                this.EditVolPrimario = true;
              };

            }
            if(principal.Volumenes.length >1)
            {
              this.ListaPrimario = true;
              this.chkNuevoVolumen = true,
              this.chkFusion = false
            }

            if(referencia.Volumenes.length ==1)
            {
              var MovimientoUnico = [];
              var vol = 0;
              var hojas= 0;
              var Contenedor = 0;
              var Estatus = 0;
              var FechaPeticion =  moment().format();
              var areaMovimiento= this.DocumentoModal.Area.AreaId;
              var usrId = 0;

              $.each(referencia.Volumenes, function(index, lista){
                vol = lista.VolumenId;
                hojas=lista.Fojas;
                Contenedor = lista.Contenedor;
                Estatus = lista.EstatusVolumenes.TipoEstatusVolumenId;
                usrId = lista.MovimientoVolumen.UsuarioQuienRecibe.IdUsuario;

                MovimientoUnico.push({
                    "VolumenId": vol,
                    "FechaMovimiento": FechaPeticion,
                    "UsuarioQuienPresta": {"IdUsuario": usrId},
                    "UsuarioQuienRecibe": {"IdUsuario": usrId},
                    "AreaQuePresta": {"AreaId": areaMovimiento},
                    "AreaQueRecibe": { "AreaId": areaMovimiento},
                    "SolicitudDocumentoId": null,
                    "Observaciones": "Movimiento por referencia de Documento",
                    "FechaRecepcion": FechaPeticion
                });
              });
              
              this.VolumenSecundario.VolumenId= vol;
              this.VolumenSecundario.Fojas= hojas;
              this.VolumenSecundario.Contenedor = Contenedor;
              this.VolumenSecundario.EstatusVolumenes.TipoEstatusVolumenId = Estatus;
              this.secundarioUnico= true;
              this.MovimientosFinales =MovimientoUnico;

              if(this.VolumenSecundario.Fojas == 0)
              {
                this.EditVolSecundario = true;
              };

            }
            if(referencia.Volumenes.length >1)
            {
              
              var Volumenes =[];
              var Movimientos = [];
              var chkFojas = 0;
              var documentoId = this.DocumentoModal.InventarioDocumentoId;
              var areaMovimiento= this.DocumentoModal.Area.AreaId;
              var FechaPeticion = moment().format();
              $.each(referencia.Volumenes, function(index, lista){
               
                Volumenes.push (
                  {
                    "VolumenId": null,
                    "Fojas": lista.Fojas,
                    "Contenedor": lista.Contenedor,
                    "Area": {"AreaId": lista.Area.AreaId},
                    "InventarioDocumentoId": documentoId,
                    "EstatusVolumenes": {"TipoEstatusVolumenId": lista.TipoEstatusVolumenId},
                    "NumVolumen": lista.NumVolumen,
                    "UsuarioQueRegistro": lista.UsuarioQueRegistro
                  }
                );
                
                if(lista.Fojas== 0)
                  {
                    lista.UsuarioQueRegistro.IdUsuario =0;
                    chkFojas +=1;
                  }
              });
              
              $.each(this.ListaVolumenSecundario, function (index, movimiento){
                Movimientos.push({
                    "VolumenId": movimiento.VolumenId,
                    "FechaMovimiento": FechaPeticion,
                    "UsuarioQuienPresta": {"IdUsuario": 0},
                    "UsuarioQuienRecibe": {"IdUsuario": 0},
                    "AreaQuePresta": {"AreaId": areaMovimiento},
                    "AreaQueRecibe": { "AreaId": areaMovimiento},
                    "SolicitudDocumentoId": null,
                    "Observaciones": "Movimiento por referencia de Documento",
                    "FechaRecepcion": FechaPeticion
                });
              });
              this.MovimientosFinales = Movimientos;
              if(chkFojas > 0)
              {
                this.EditRowListado = true;
              };
              this.chkNuevoVolumen = true,
              this.chkFusion = false
              this.ReferenciaDocumento.Volumenes = Volumenes;
              this.ListaSecundario = true;
              this.ListaFinalReferencias = this.ReferenciaDocumento.Volumenes;
            };

          }
          else
          {
            comun.mensajeDeAlerta("Selecciones un tipo de Referencia", null, null);
          }

        },
        Finalizar(){
          if (this.VerificarFinalizado() == true)
          {
            this.AgregarReferencia();
          }
        },
        VolverBusqueda(){
          this.ReferenciaDocumento =  null;
          this.MostrarBusqueda = true;
          this.MostraResultado = false;
          this.MostrarFusion = false;
        },
        VerificarFinalizado(){
          if(this.DocumentoModal.Volumenes.length == 1 && this.primarioUnico == true) 
          {
            if(this.VolumenPrincipal.Fojas ==0)
            {
            comun.mensajeDeAlerta("Actualizar las fojas del Volumen del Documento Principal", null, null);
            return false
            }
          };
          if(this.ReferenciaDocumento.Volumenes.length == 1 && this.secundarioUnico == true)
          {
            if(this.VolumenSecundario.Fojas == 0)
            {
              comun.mensajeDeAlerta("Actualizar las fojas del Volumen del Documento de Referencia", null, null);
              return false
            }
          };
          if(this.ReferenciaDocumento.Volumenes.length>1)
          {
            var EnCeros= 0;
            $.each(this.ReferenciaDocumento.Volumenes, function(index, listado){
              
              if(listado.Fojas == 0)
              {
                EnCeros += 1;
              }
            });
            
            if(EnCeros>0){
              comun.mensajeDeAlerta("Actualizar las fojas del Volumen del Documento de Referencia", null, null);
              return false;
            };
          };
          if(this.chkFusion == true && this.chkNuevoVolumen == true)
          {
            comun.mensajeDeAlerta("Seleccionar solo un metodo de gestión de Volumenes", null, null);
            return false
          }
          if(this.chkFusion == false && this.chkNuevoVolumen == false)
          {
            comun.mensajeDeAlerta("Seleccionar un metodo de gestión de Volumenes", null, null);
            return false
          }
          return true;

        }
    },
    mounted(){
      this.DocumentoModal = this.DocumentoPrincipal;
      this.MostrarBusqueda = true;
      this.Titulo= "Referencia de Documento: Busqueda";
      this.Mostrar();
        
    }
    
}
</script>
<style scoped>
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: none;
    overflow: hidden;
    outline: 0;
  }

  input[type="text"]:read-only {
    background: #504f54;
  }
  input[type="text"]:read-only:focus {
      color: #fff;
  }
  input[type="number"]:read-only {
    background: #504f54;
  }
  input[type="number"]:read-only:focus {
      color: #fff;
  }
  .modal-content {
      background-color:  #7e7f74;
  }
  .modal-header {
        background-color:  #007573;
    }

</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/ModalReferencia.vue